import { render } from "./DeliveryNoteIndex.vue?vue&type=template&id=022dc087"
import script from "./DeliveryNoteIndex.vue?vue&type=script&lang=js"
export * from "./DeliveryNoteIndex.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__